export const GET_JOBS = 'app/get_jobs'
export const GET_JOB_BY_ID = 'app/get_job_by_id'
export const DELETE_JOB_BY_ID = 'app/delete_job'
export const CREATE_JOB = 'app/create_job'
export const UPDATE_JOB = 'app/update_job'
